import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import { useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import RiskDialogBox from '../../RiskDialogBox';
import ViewAllAlerts from '../../ViewAllAlerts';
import AlertService from '../../../../services/console_services/Alerts';
import Loading from '../../Loading';
const useStyles = makeStyles((theme) => ({
    card: {
        height: "auto",
        borderRadius: "8px",
        background: "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.05), 0px 2px 16px 0px rgba(0, 0, 0, 0.10)",
        padding: "10px",
        border: "0px !important",
        [theme.breakpoints.down('sm')]: {
            height: "auto",
            padding: "5px",
        },
    },
    header: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            flexDirection: "column",
            alignItems: "flex-start",
        },
    },
    alert: {
        margin: 0,
        padding: theme.spacing(1),
        fontSize: "16px !important",
        fontWeight: "600 !important",
        color: "#333",
        [theme.breakpoints.down('sm')]: {
            fontSize: "14px !important",
        },
    },
    alertCount: {
        width: "20px",
        height: "20px",
        borderRadius: "50%",
        backgroundColor: "#DCE0EA",
        border: "none",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "10px",
        fontWeight: 600,
        marginLeft: "10px",
        [theme.breakpoints.down('sm')]: {
            width: "16px",
            height: "16px",
            fontSize: "8px",
            marginLeft: "5px",
        },
    },
    viewAllButton: {
        fontSize: "13px !important",
        color: "#333 !important",
        fontWeight: 500,
        fontFamily: 'Poppins, sans-serif',
        [theme.breakpoints.down('sm')]: {
            fontSize: "11px !important",
        },
    },
    cardContent: {
        padding: "0px 10px !important",
        [theme.breakpoints.down('sm')]: {
            padding: "0px 5px !important",
        },
    },
    loaderContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '90vh',
    },
}));

const Distribution_Planning_AlertDialogBox = ({ handleViewAll, viewAll, _viewAllAlertData, handleViewPowerBi }) => {
    const { Network, DC, PL3, Division, Products } = useSelector((state) => state?.filter);
    const { tabName } = useSelector((state) => state?.tabs);
    const [alertsData, setAlertsData] = useState([]);
    const [loading, setLoading] = useState(true);
    // const tempFix = 'SNO';
    const { instance } = useMsal();

    const getViewAllAlertData = () => {
        const params = { filter: {}, module: tabName };
          if (module === "DO" || module === "DP") {
            params.filter = {
              RecommendedDC: DC,
              Network,
              PL3,
              Division,
              MaterialID: Products,
            };
          } else {
            if (Network) {
              params.filter.Network = Network;
            } else if (DC) {
              params.filter.RecommendedDC = DC;
            }
          }
        setLoading(true);
        AlertService.getAllAlertsAtViewAll(params, instance).then(data => {
            if(data?.data){
                setAlertsData(data?.data);
            }
        })
        .catch(error => console.error('Error:', error))
        .finally(() => setLoading(false));
    };

    useEffect(() => {
        getViewAllAlertData();
    }, [tabName, Network, DC, Products, Division, PL3]);

    const classes = useStyles();

    const handleClickViewAll = () => {
        handleViewAll();
    };

    const handleClose = () => {
        handleViewAll();
    };
    // const formatValue = (value, format) => {
    //     let formattedText = '';

    //     if (format === "$") {
    //         // Formatting as currency with handling for negative values
    //         const numericValue = Math.abs(Number(value));
    //         if (numericValue >= 1_000_000) {
    //             formattedText = `$${(numericValue / 1_000_000).toFixed(2)}M`;
    //         } else if (numericValue >= 1_000) {
    //             formattedText = `$${(numericValue / 1_000).toFixed(2)}K`;
    //         } else {
    //             formattedText = `$${numericValue.toFixed(2)}`;
    //         }
    //         if (Number(value) < 0) {
    //             formattedText = `-$${formattedText.replace('$', '')}`;
    //         }
    //     } else {
    //         // Formatting as percentage (assuming format '%' for percentages)
    //         formattedText = value >= 1 ? `${value.toFixed(2)}%` : `${(value * 100).toFixed(2)}%`;
    //     }

    //     return formattedText;
    // };

    return (
        <div>
            <Card className={classes.card}>
                {loading ?
                    <div className={classes.loaderContainer}>
                        <Loading />
                    </div> : <>
                        <div className={classes.header}>
                            <Typography className={classes.alert} id="customized-dialog-title">
                                Alerts
                                <span className={classes.alertCount}>{alertsData.length}</span>
                            </Typography>
                            <IconButton
                                aria-label="close"
                                onClick={handleClickViewAll}
                                className={classes.viewAllButton}
                            >
                                View All
                            </IconButton>
                        </div>
                        <CardContent className={classes.cardContent}>
                            {(() => {
                                if (!alertsData || alertsData.length === 0) {
                                    return null;
                                }
                                // Filter and sort the data
                                const costReductionData = alertsData
                                    .filter(val => val.Metric === "Payload Decrease")
                                    .sort((a, b) => a.Metric_value - b.Metric_value) // Sort by least negative
                                    .slice(0, 2); // Get the top 2 least negative values

                                const cofIncreaseData = alertsData
                                    .filter(val => val.Metric === "Stockout_Count")
                                    .sort((a, b) => b.Metric_value - a.Metric_value) // Sort by largest positive
                                    .slice(0, 2); // Get the top 2 largest values

                                // Combine the data in the specified order
                                const combinedData = [
                                    ...cofIncreaseData,   // 1st: Top 2 COF_Increase
                                    ...costReductionData, // 2nd: Top 2 Cost_Reduction
                                    ...cofIncreaseData,   // 3rd: Repeat Top 2 COF_Increase
                                    ...costReductionData  // 4th: Repeat Top 2 Cost_Reduction
                                ].slice(0, 4); // Ensure only 4 data points are displayed

                                return combinedData.map(val => {
                                    const metricValue = Number(val.Metric_value);
                                    const format = val.Metric === "";
                                    const subTitle = val.Metric === "Payload Decrease"
                                        ? `Due to rise of stock out this week in ${val.Name}`
                                        : `In ${val.Name} this weeks`;

                                    return (
                                        <RiskDialogBox
                                            key={val.Alert_id}
                                            value={metricValue}
                                            maxValue={"100"}
                                            alerts={val}
                                            handleViewPowerBi={handleViewPowerBi}
                                            format={format}
                                            title={val.Metric === 'Stockout_Count' ? "STRs need Approval " : "Payload Decrease"}
                                            subTitle={subTitle}
                                        />
                                    );
                                });
                            })()}
                        </CardContent>
                    </>}
            </Card>
            <ViewAllAlerts
                open={viewAll}
                handleClose={handleClose}
                handleViewAll={handleClickViewAll}
            />
        </div>
    );
};

export default Distribution_Planning_AlertDialogBox;
